import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Lock } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const NAV = [
  { label: "Events",      href: "#events" },
  { label: "Housing",     href: "#housing" },
  { label: "Business",    href: "#business-directory" },
  { label: "Jobs",        href: "#jobs" },
  { label: "Community",   href: "#community-board" },
];

export function Header() {
  const [scrolled, setScrolled]   = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setMobileOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "apple-glass border-b border-black/10 shadow-sm"
          : "bg-white/0"
      }`}
    >
      <div className="max-w-[980px] mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-[52px]">
          {/* Logo */}
          <a
            href="#top"
            onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
            className="text-[21px] font-semibold text-[#1d1d1f] tracking-tight leading-none"
            style={{ letterSpacing: "-0.02em" }}
          >
            NC Desi
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((item) => (
              <button
                key={item.href}
                onClick={() => go(item.href)}
                className="px-4 py-2 text-[14px] text-[#1d1d1f] hover:text-[#0071e3] rounded-full hover:bg-black/5 transition-colors duration-150"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => go("#newsletter")}
              className="hidden sm:inline-flex items-center justify-center bg-[#0071e3] hover:bg-[#0077ed] text-white text-[14px] font-medium px-[18px] py-[8px] rounded-[980px] transition-colors duration-150"
            >
              Join free
            </button>
            <button
              className="lg:hidden p-2 rounded-full hover:bg-black/5 transition-colors"
              onClick={() => setMobileOpen((v) => !v)}
              aria-label="Menu"
            >
              {mobileOpen ? <X className="w-5 h-5 text-[#1d1d1f]" /> : <Menu className="w-5 h-5 text-[#1d1d1f]" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
            className="lg:hidden overflow-hidden apple-glass border-b border-black/10"
          >
            <div className="px-4 py-4 flex flex-col gap-1 max-w-[980px] mx-auto">
              {NAV.map((item) => (
                <button
                  key={item.href}
                  onClick={() => go(item.href)}
                  className="text-left px-4 py-3 rounded-xl text-[#1d1d1f] hover:bg-black/5 transition-colors text-[15px] font-medium"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => go("#newsletter")}
                className="text-left px-4 py-3 mt-1 rounded-xl bg-[#0071e3] text-white text-[15px] font-medium"
              >
                Join Free
              </button>
              <Link
                to="/admin"
                className="flex items-center gap-2 px-4 py-3 rounded-xl text-[#6e6e73] hover:bg-black/5 text-[14px]"
              >
                <Lock className="w-4 h-4" /> Admin Portal
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
